/**
 * 株主優待モードの状態管理。
 *
 * 以前は sessionStorage に保存していたが、sessionStorage はタブ単位で消えるため
 * 別タブを開いた時点で「優待商品は表示されるのに割引だけ効かない」状態になり、
 * 割引されないまま決済される事故が起きていた。
 * タブ間で共有されるCookieに保存場所を変更している。
 *
 * 有効期間はカートの有効期間（およそ14日）に合わせている。
 * ここが長すぎると、Locksmithの解錠（カートに紐づく）が先に切れて
 * 「バーは出ているのに優待商品が表示されない」という逆の食い違いが起きるため。
 */
window.YutaiMode = (function () {
  var COOKIE_NAME = 'yutai_code';
  var MAX_AGE = 60 * 60 * 24 * 14;

  function get() {
    var matched = document.cookie.match('(^|; )' + COOKIE_NAME + '=([^;]*)');
    var fromCookie = matched ? decodeURIComponent(matched[2]) : '';
    if (fromCookie) return fromCookie;

    // 移行期間の互換用。旧方式で登録済みの利用者を切り捨てないため、
    // Cookieが無い場合のみ sessionStorage も参照する。
    var legacy = null;
    try {
      legacy = sessionStorage.getItem('code');
    } catch (e) {
      return null;
    }
    // 旧方式で見つかった場合はCookieへ移し替える。
    // ここで昇格させないと、旧方式の利用者は別タブ問題が解消されないままになる。
    if (legacy) set(legacy);
    return legacy || null;
  }

  function set(code) {
    document.cookie =
      COOKIE_NAME + '=' + encodeURIComponent(code) +
      '; path=/; max-age=' + MAX_AGE + '; SameSite=Lax; Secure';
    try {
      sessionStorage.setItem('code', code);
    } catch (e) {}
  }

  function clear() {
    document.cookie = COOKIE_NAME + '=; path=/; max-age=0; SameSite=Lax; Secure';
    // Shopify側に保存した割引クーポンも一緒に消す。
    // ここを残すと「テーマ上は非優待モードなのにチェックアウトでは割引が付く」
    // という逆方向の不整合が起きる。
    document.cookie = 'discount_code=; path=/; max-age=0';
    try {
      sessionStorage.removeItem('code');
    } catch (e) {}
  }

  return { get: get, set: set, clear: clear };
})();
